import { useEffect } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import clienteAxios from "../../axios";
import Encrypt from '../../Helpers/Encrypt';
import logo from '../../img/favicon.png';
import { useAuth } from '../../context/AuthContext';

const Login = () => {
  const [celular, setCelular] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [token, setToken] = useState('');

     const { login } = useAuth();  

 

  

  const handleSubmit = async (e) => {
    e.preventDefault();    
    try {
      const response = await clienteAxios.post("api/usuarios/login", {
        "op": "login",
        "celular": celular,
        "clave": Encrypt(password)
      });      
      if (response.status === 200 && response.data.token) {
        const now = new Date().getTime();
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('data', JSON.stringify(response.data));
         setToken(response.data.token);
        login();
        navigate("/");
          window.location.reload();
      } else {
        setError("Credenciales inválidas");
      }
    } catch (error) {
      console.error("Error en el inicio de sesión:", error); // Log del error
      setError("Error al iniciar sesión, intenta de nuevo.");
    }
  };



  return (
    <>
      <div className="mx-auto max-w-2xl text-left">
        <div className="flex flex-1 flex-col justify-center px-4 py-12 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
          <div className="mx-auto w-full max-w-sm lg:w-96">
            <div>             
              <h2 className="mt-8 text-2xl font-bold leading-9 tracking-tight text-gray-900 text-center">
                Inicia sesión en tu cuenta
              </h2>
            </div>

            <div className="mt-10">
              <div>
                <form onSubmit={handleSubmit} className="space-y-6">
                  <div>
                    <label htmlFor="celular" className="block text-sm font-medium leading-6 text-gray-900">
                      Celular
                    </label>
                    <div className="mt-2">
                      <input
                        id="celular"
                        name="celular"
                        value={celular}
                        onChange={(e) => setCelular(e.target.value)}
                        required
                        maxLength={10} 
                        inputMode="numeric" 
                        pattern="\d*" 
                        autoComplete="tel"
                        className="block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:text-sm sm:leading-6"
                      />
                    </div>
                  </div>

                  <div>
                    <label htmlFor="password" className="block text-sm font-medium leading-6 text-gray-900">
                      Password
                    </label>
                    <div className="mt-2">
                      <input
                        id="password"
                        name="password"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        autoComplete="current-password"
                        className="block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:text-sm sm:leading-6"
                      />
                    </div>
                  </div>

                  {error && (
                    <div className="text-red-600 text-sm">
                      {error}
                    </div>
                  )}

                

                  <div>

                    <button
                      type="submit"
                      className="flex w-full justify-center rounded-md bg-pink-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-pink-500"
                    >
                      Ingresar
                    </button>

                  </div>
                </form>
              </div>

              <div className="mt-10">
                <div className="relative">
                  <div aria-hidden="true" className="absolute inset-0 flex items-center">
                    <div className="w-full border-t border-gray-200" />
                  </div>
                </div>

                <div className="mt-6 grid grid-cols-2 gap-4"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
